import configJson from "./auth_config.json";

export function getConfig() {
  const audience =
    configJson.audience && configJson.audience !== "YOUR_API_IDENTIFIER"
      ? configJson.audience
      : undefined;

  return {
    domain: configJson.domain,
    clientId: configJson.clientId,
    ...(audience && { audience }),
    apiUrl: configJson.apiUrl
  };
}

export function getAPIUrl() {
  return getConfig().apiUrl;
}
